export const priceFormatter = (price, round = false) => {
  let decimals = 2
  if (!price) {
    throw new Error('Price cannot be empty')
  }

  if (round && price.toString().length >= 6) {
    price = Math.round(price)
    decimals = 0
  }

  return Number(price)
    .toLocaleString('en-US', { minimumFractionDigits: decimals })
    .replace(',', ' ')
    .replace('.', ',')
}
